<template>
  <div class="row">
    <div class="col-md-3">
      <vuestic-simple-select
        label="Campo"
        v-model="selected"
        option-key="description"
        v-bind:options="options"
        v-if="showFilter">
      </vuestic-simple-select>
    </div>
    <div class="col-md-3">
      <div class="form-group with-icon-left" v-if="showFilter">
        <div class="input-group">
          <input id="input-icon-left" name="input-icon-left" v-model="searchText" required/>
          <i class="glyphicon glyphicon-search icon-left input-icon search-icon"></i>
          <label class="control-label" for="input-icon-left">Comienza con</label><i class="bar"></i>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <datetime v-model="formatDate" value-zone="UTC" zone="UTC" style="width: 100%; text-align: center;" v-if="date"></datetime>
    </div>
    <div class="col-md-3">
      <button id="itemsPerPageBtn" class="btn btn-primary btn-sm" type="button"  @click="doFilter()">
        Buscar
      </button>
    </div>
  </div>
</template>

<script>
  import { Datetime } from 'vue-datetime'
  import 'vue-datetime/dist/vue-datetime.css'
  export default {
    name: 'simple-filter',
    components: {
      Datetime,
    },
    props: {
      onFind: {
        type: Function,
        default: function (t, m) { console.log('On Find', t, m) }
      },
      date: {
        type: Object
      },
      selectedField: {
        type: Object,
        default: () => null
      },
      filterText: {
        type: String,
        default: ''
      },
      filterFields: {
        type: Array,
        default: () => []
      },
    },
    data () {
      return {
        formatDate: null,
        searchText: '',
        options: [],
        selected: null,
        showFilter: false
      }
    },
    created () {
      let vue = this
      vue.searchText = this.filterText
      if (this.date) vue.formatDate = this.date.format()
      if (vue.filterFields.length > 0) {
        vue.showFilter = true
        if (vue.selectedField) {
          vue.selected = vue.selectedField
        } else {
          vue.selected = vue.filterFields[0]
        }
      }
      vue.filterFields.forEach(function (field) {
        vue.options.push(field)
      })
    },
    methods: {
      doFilter () {
        this.onFind(this.formatDate, this.searchText, this.selected)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-icon {
    transform: rotate(90deg);
  }

  .form-group {
    min-width: 7rem;
  }

  //Para select 
  .v-select .dropdown-menu .active>a {
    color: red;
  }

  .v-select .dropdown-menu >a {
    color: black;
  }

  @media (max-width: 768px) {
    .form-group {
      width: 80%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-datatable/datatable-components/SimpleFilter.vue